export default "__VITE_ASSET__CZHO73KC__"